var _defs, _path, _polygon, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCandidatoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.26 64.86",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m47.16,45.89c-.49,2.15-2.63,3.51-4.78,3.02-2.15-.49-3.51-2.63-3.02-4.78.48-2.15,2.63-3.51,4.78-3.02,2.15.48,3.51,2.63,3.02,4.78Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "32.08 64.86 34.4 59.35 32.05 53.86 45.1 59.32 32.08 64.86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.53,28.18c-4.34,0-8.3-3.36-9.02-7.64l-1.37-8.28c-.54-3.23.25-6.3,2.23-8.64,1.98-2.34,4.88-3.63,8.16-3.63s6.17,1.29,8.15,3.62c1.98,2.34,2.78,5.41,2.24,8.64h0s-1.38,8.28-1.38,8.28c-.69,4.21-4.73,7.64-9.01,7.64Zm0-24.18c-2.09,0-3.9.79-5.11,2.21-1.21,1.42-1.68,3.34-1.34,5.39l1.37,8.28c.39,2.33,2.71,4.3,5.08,4.3s4.68-1.97,5.06-4.29l1.38-8.28c.34-2.06-.14-3.97-1.35-5.4-1.21-1.42-3.02-2.21-5.1-2.21Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m35.02,61.15H0v-26.64c0-2.72,2.02-5.53,4.61-6.41l7-2.33.87,1.09c2.52,3.15,6.27,5.02,10.05,5.02s7.53-1.88,10.05-5.02l.87-1.09,7,2.33c2.59.87,4.61,3.68,4.61,6.41v8.56h-4v-8.56c0-1.02-.92-2.29-1.88-2.62l-4.41-1.47c-3.23,3.44-7.71,5.46-12.24,5.46s-9.01-2.02-12.24-5.46l-4.41,1.47c-.96.33-1.88,1.6-1.88,2.61v22.64h31.02v4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidatoWhite);
export default __webpack_public_path__ + "static/media/candidato-white.a233332f4e25961fbe2bab08ee18e823.svg";
export { ForwardRef as ReactComponent };